<template>
  <div class="dashboard-container">
    <side-bar />
    <div class="main-content">
      <h2>Customers
        <!-- <button class="title-btn" @click="$router.push('/partner/new-customer')">
          <font-awesome-icon icon="fa-user-plus" />
          New customer
        </button> -->
      </h2>
      <hr class="h2" />
      <div class="container">
        <customer-table />
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from './SideBar.vue'
import CustomerTable from '../vuetify/CustomerTable.vue'

export default {
  name: 'ManageCustomers',
  components: {
    SideBar,
    CustomerTable,

  },
  mounted() {
    if (!localStorage.getItem('partnerGuid')) {
      this.$router.push('/home');
    }
    // Reset bot details
    localStorage.removeItem('botName');
    localStorage.removeItem('botID');
    localStorage.removeItem('botType');
    localStorage.removeItem('botDID');
  }
}
</script>

<style scoped>
.fa-user-plus {
  margin-right: 5px;
}

.container {
  margin-top: 20px;
}
</style>